import { API_BASE_URL, getTenantId } from '../config/api';

class AbonnementService {
  async apiCall(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      ...options
    };

    // Token d'authentification
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Extraire le tenant_id depuis l'utilisateur
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const tenantId = user.tenant_id;
    config.headers['x-tenant-id'] = tenantId;

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API call failed:', error);
      throw error;
    }
  }

  // Récupérer les plans d'abonnement avec statistiques
  async getPlans(filters = {}) {
    const queryParams = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        queryParams.append(key, filters[key]);
      }
    });

    const queryString = queryParams.toString();
    const endpoint = queryString ? `/abonnements?${queryString}` : '/abonnements';
    
    return await this.apiCall(endpoint);
  }

  // Récupérer un plan d'abonnement par ID
  async getPlan(id) {
    return await this.apiCall(`/abonnements/${id}`);
  }

  // Créer un nouveau plan d'abonnement
  async createPlan(planData) {
    return await this.apiCall('/abonnements', {
      method: 'POST',
      body: JSON.stringify(planData)
    });
  }

  // Mettre à jour un plan d'abonnement
  async updatePlan(id, planData) {
    return await this.apiCall(`/abonnements/${id}`, {
      method: 'PUT',
      body: JSON.stringify(planData)
    });
  }

  // Changer le statut d'un plan (activer/désactiver)
  async togglePlanStatus(id, isActive) {
    return await this.apiCall(`/abonnements/${id}/status`, {
      method: 'PUT',
      body: JSON.stringify({ is_active: isActive })
    });
  }

  // Supprimer un plan d'abonnement
  async deletePlan(id) {
    return await this.apiCall(`/abonnements/${id}`, {
      method: 'DELETE'
    });
  }

  // Fonctions utilitaires pour les features
  getDefaultFeatures() {
    return [
      { id: 'one_service_type', label: '1 type de service actif (transport ou livraison ou location)', checked: false },
      { id: 'up_to_3_services', label: 'Jusqu\'à 3 services actifs en simultané (transport, livraison, location)', checked: false },
      { id: 'priority_display', label: 'Affichage prioritaire dans les résultats de recherche', checked: false },
      { id: 'map_visibility', label: 'Profil visible sur la carte et dans les recherches', checked: false },
      { id: 'reviews_access', label: 'Accès aux avis et notations', checked: false },
      { id: 'email_support', label: 'Support client basique par e-mail', checked: false },
      { id: 'quarterly_limit', label: '50 trajets ou livraisons maximum par trimestre', checked: false },
      { id: 'monthly_limit_30', label: '30 trajets ou livraisons maximum par mois', checked: false },
      { id: 'monthly_limit_150', label: '150 trajets ou livraisons maximum par trimestre', checked: false },
      { id: 'up_to_3_vehicles', label: 'Jusqu\'à 3 véhicules déclarés', checked: false },
      { id: 'limited_stats', label: 'Accès limité aux statistiques (volume de demandes, performances)', checked: false },
      { id: 'monthly_limit_500', label: '500 trajets ou livraisons maximum par an', checked: false },
      { id: 'up_to_10_vehicles', label: 'Jusqu\'à 10 véhicules déclarés', checked: false },
      { id: 'unlimited_reservations', label: 'Réservations simultanées illimitées', checked: false },
      { id: 'one_vehicle_only', label: '1 seul véhicule déclaré', checked: false },
      { id: 'no_advanced_stats', label: 'Pas d\'accès aux statistiques avancées', checked: false },
      { id: 'unlimited_services', label: 'Accès illimité à tous les types de services', checked: false },
      { id: 'premium_visibility', label: 'Visibilité premium dans les résultats', checked: false },
      { id: 'complete_dashboard', label: 'Accès complet au tableau de bord des performances', checked: false },
      { id: 'verified_badge', label: 'Badge vérifié + service client prioritaire', checked: false }
    ];
  }

  // Formater les features pour l'affichage
  formatFeatures(features) {
    const defaultFeatures = this.getDefaultFeatures();
    return defaultFeatures.map(feature => ({
      ...feature,
      checked: features[feature.id] || false
    }));
  }

  // Convertir les features en objet pour l'API
  featuresToObject(featuresArray) {
    const result = {};
    featuresArray.forEach(feature => {
      result[feature.id] = feature.checked;
    });
    return result;
  }
}

export default new AbonnementService();